import dayjs from "dayjs";
import HotelDatepicker from "hotel-datepicker";
import "hotel-datepicker/dist/css/hotel-datepicker.css";
import React, { useEffect, useRef, useState } from "react";
// import "react-dates/initialize";
import { useSelector } from "react-redux";
import calendar from "../../assets/images/calendar.svg";
import user from "../../assets/images/user.svg";
import useWindowSize from "../../utils/useWindowSize";
import { useTranslation } from "react-i18next";
import { pluralWords } from "../../utils/utils";

const Dates = ({
  dateRange,
  setDateRange,
  location,
  setEnablePopup,
  style,
}) => {
  const [dateComp, setDateComp] = useState(null);

  const { width } = useWindowSize();

  const inputRef = useRef();

  const onDatesChange = (dp) => {
    let tempDt = dp?.getValue()?.split("-");
    setDateRange({
      startDate: dayjs(tempDt[0]).format("YYYY/MM/DD"),
      endDate: dayjs(tempDt[1]).format("YYYY/MM/DD"),
    });
  };

  const closeDates = (dp) => {
    // const { startDate, endDate } = evt;
    onDatesChange(dp);
    setEnablePopup(true);

    // fireGtmEvent("dates_changed", {
    //   startDate: moment(startDate).format("ddd, DD MMM'YY"),
    //   endDate: moment(endDate).format("ddd, DD MMM'YY"),
    // });
  };

  const {
    dateRange: prevDate,
    totalPeople,
    hotelData,
  } = useSelector((state) => state.hotelInfo);

  useEffect(() => {
    prevDate?.startDate && (dateRange.startDate = dayjs(prevDate.startDate));

    prevDate?.endDate && (dateRange.endDate = dayjs(prevDate?.endDate));
  }, []);

  useEffect(() => {
    const input = inputRef.current;
    if (!input) return;

    var datePicker = new HotelDatepicker(input, {
      format: "DD MMM YY",
      showTopbar: false,
      moveBothMonths: true,
      // startDate: new Date(),
      // minNights: hotelData?.minBookingNights || 1,
    });
    input.addEventListener("afterClose", () => closeDates(datePicker), false);
    datePicker.setValue(
      `${dayjs(prevDate.startDate).format("DD MMM YY")} - ${dayjs(
        prevDate.endDate
      ).format("DD MMM YY")}`
    );
    // datePicker.setValue(
    //   `${dayjs(hotelData?.checkInDate || prevDate.startDate).format(
    //     "DD MMM YY"
    //   )} - ${dayjs(hotelData?.checkOutDate || prevDate.endDate).format(
    //     "DD MMM YY"
    //   )}`
    // );
    setDateComp({ ...dateComp, ...datePicker });
  }, []);
  // }, [hotelData?.id]);

  const { t } = useTranslation();

  return (
    <div className="dates" style={style}>
      {width > 900 && <p>{t("checkin_checkout")}</p>}
      <div className="dateContainer">
        <img src={calendar} width={"20px"} alt="calendar" height={"100%"} />
        <input
          type="text"
          id="date-input"
          placeholder={t("checkin_checkout")}
          readOnly
          ref={inputRef}
        />
      </div>
      {width > 900 && <p>{t("guests")}</p>}

      <div className="peopleContainer" onClick={() => setEnablePopup(true)}>
        <img src={user} alt="user" width={"25px"} height={"100%"} />{" "}
        {totalPeople} {t(pluralWords(totalPeople, "guest"))}
      </div>
    </div>
  );
};

export default Dates;